import { agent } from 'src/api/agent';
import { throwApiError } from 'src/api/utils';
import type { OBJECT_TYPE, RemovableRigObjectType } from 'src/api/wells-list/types';

export async function copyGeologicalTask(
  planVersionId: number,
  geologicalTaskId: number,
  wellPlacementId: number,
): Promise<Record<string, unknown>> {
  try {
    const { data } = await agent.get<Record<string, unknown>>(`well/copyGeologicalTask/${geologicalTaskId}`, {
      params: { planVersionId, wellPlacementId },
    });

    return data;
  } catch (e) {
    throwApiError(e);
  }
}

export async function deleteWells(wellIds: number[], planVersionId: number): Promise<void> {
  try {
    await agent.delete('well', {
      data: wellIds,
      params: { planVersionId },
    });
  } catch (e) {
    throwApiError(e);
  }
}

export async function removeRig(
  planVersionId: number,
  objectType: OBJECT_TYPE,
  objectIdList: number[],
): Promise<RemovableRigObjectType[]> {
  try {
    const { data } = await agent.post<RemovableRigObjectType[]>('rig/removeRig', null, {
      params: { planVersionId, objectType, objectIdList: objectIdList.join() },
    });

    return data;
  } catch (e) {
    throwApiError(e);
  }
}
